// Average energy density across our recipes (circa 1.70 kcal/g, varies by recipe).
// Displayed/stored calories are derived from the portioned grams so they match
// what's actually in the bowl, rather than the pre-rounding MER estimate.
export const FOOD_KCAL_PER_GRAM = 1.7;

export const caloriesFromGrams = (grams: number | string) =>
  Math.round((Number(grams) || 0) * FOOD_KCAL_PER_GRAM);
